import DOMPurify from 'dompurify';

var MultiPartSentenceStarter = require("components/writing/questions/MultiPartSentenceStarter");

require("writing/answers/multi_part_answer_display.scss");

var MultiPartAnswerDisplay = function(props) {
	var index = 0;
	var sections = [];
	// for question builders
	var synonyms = [];

	var renderText = (text) => {
		// if part contains html tags, render them
		// if part doesn't contain html tags, render it as text
		if (text.match(/<[^>]*>/)) {
			return <span dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(text)}}></span>
		} else {
			return text
		}
	}

	_.each(props.parts || [], (part, index) => {
		if (props.metaCognitive) {
			if (part.type == QUESTION) {
				sections.push(
					<span key={"question-body-" + index} className="inputText">
						<strong>Question:</strong> {part.text}<br/>
					</span>
				)
			} else if (part.type == ANSWER) {
				sections.push(
				<span key={"answer-body-" + index} className="inputText">
					<strong>Answer:</strong> {part.text}
				</span>
				)
			} else if (part.type = SYNONYM) {
				_.times(3, (i) => {
					if (part[i]) {
						synonyms.push(part[i]);
					}
				})
			}
		}
		else if (part.type == STARTER) {
			if (index != 0 && props.breakSections) {
				sections.push(
					<span key={ "br-" + index }>
						<br /><br />
					</span>
				)
			}
			sections.push(
				<span key={ "starter-" + index }>
					<span className="starter">
						{ part.text }
					</span>{" "}
				</span>
			);
		}
		else {
			sections.push(
				<span key={ "body-" + index } className="inputText">
					{ renderText(part.text) }
				</span>
			)
		}
	})

// for question builders
	if (synonyms.length) {
		if (synonyms.length === 1) {
			var synonymsList = _.first(synonyms)
		} else {
			var synonymsList = synonyms.slice(0, -1).join(', ') + ' and ' + synonyms.slice(-1)
		}
		sections.push(<br key={"synonyms-break-" + index}/>)
		sections.push(
			<span key={"body-" + index} className="inputText">
				<strong>Synonyms:</strong> {synonymsList}
			</span>
		)
	}

	var className = "multiPartAnswerDisplay";
	if (props.emphasizeInputs) {
		className += " emphasizeInputs";
	} else {
		className += " emphasizeStarters";		
	}

	return (
		<div className={ className }>
			{ sections }
		</div>
	);
};

var BODY = MultiPartSentenceStarter.BODY;
var STARTER = MultiPartSentenceStarter.STARTER;
var QUESTION = MultiPartSentenceStarter.QUESTION;
var ANSWER = MultiPartSentenceStarter.ANSWER;
var SYNONYM = MultiPartSentenceStarter.SYNONYM;

MultiPartAnswerDisplay.propTypes = StrictPropTypes({
	parts: PropTypes.array,
	breakSections: PropTypes.bool,
	emphasizeInputs: PropTypes.bool,
	metaCognitive: PropTypes.bool
});

module.exports = MultiPartAnswerDisplay;



// WEBPACK FOOTER //
// ./modules/components/writing/answers/MultiPartAnswerDisplay.js